export default __webpack_public_path__ + "static/media/motivations.42d7c928.mp3";